/**
 * Say that something about a run's conversation went wrong where nobody would
 * see it (review of !252): a thread that would not load, a refusal whose code
 * the client does not know, a write that failed without the service refusing
 * it. The person sees an error line or a toast; this is for whoever has to
 * find out why. The same shape as `notifications/report.ts`.
 */
export function reportThreadProblem(
  message: string,
  context: Record<string, unknown>,
): void {
  console.warn(`run thread: ${message}`, context);
}
